import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-route-icon',
  templateUrl: './navigation-route.component.html'
})
export class NavigationRouteComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
